import { fetchCatalogs } from "../../helpers/fetch";
import { ProfileViewProfile } from "../interfaces/profileView.model";

export const getProfileViewService = async (idCompany: string, idInvestor: string): Promise<ProfileViewProfile[]> => {
  // const res = await fetchCatalogs("prod/company/profile?company_id=" + idCompany);
  const res = await fetchCatalogs("prod/company/publicprofile?company_id=" + idCompany + "&iIdInvestor=" + idInvestor);
  return await res.json();
};
